import { Box, Text } from "@chakra-ui/react";
import IndividualCard from "./IndividualCard";

export default function ItemsList({ items }) {
    return (
        <Box
            width='100%'
            d='flex'
            flexDir='column'
            bg='white'
            border='1px solid rgba(0, 0, 0, 0.1)'
            borderRadius='10px'
            boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
            px='1rem'
        >
            {
                items.length > 0 ?
                    items.map((item, idx) => <IndividualCard
                        key={idx}
                        id={idx}
                        name={item.title}
                        image={item.cover_image ? item.cover_image : null}
                        joined={item.joined}
                        completed={item.completed}
                        in_progress={item.pending}
                    />) :
                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontSize='16px'
                        fontWeight='600'
                        color='#222222'
                        textAlign='center'
                        mt='2rem'
                    >
                        {"No Data Available Yet!"}
                    </Text>
            }
        </Box>
    )
}